import {default as React, useEffect, useState} from "react";
import "../Headers/Header.css";
import HomeHeader from "../HomeHeader";
import "../HomeHeader.css";
import SideBar from "../SideBar/SideBar";
import {deleteHL7Node, getHL7configs,} from "../utilities/HL7utils";

import HL7ConfigModal from "./HL7ConfigModals/HL7ConfigModal";
import HL7NodeModal from "./HL7NodeModal";
import HL7ConfigTable from "./HL7ConfigTable";
import LoaderComponent from "../ConfigurePages/LoaderComponent/LoaderComponent";

const HL7Config = () => {
  const [sortBy, setsortBy] = useState("");
  const [currentPage, setcurrentPage] = useState(0);
  const [loader, setloader] = useState(true);
  const [count, setCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [add, setAdd] = useState(false);
  const [asc, setAsc] = useState(false);
  const [flag, setFlag] = useState(false);
  const [search, setSearch] = useState("");
  const [searchflag, setsearchflag] = useState(false);
  const [hL7Configs, setHL7Configs] = useState();
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [deleteID, setDeleteID] = useState();
  const [update, setUpdate] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editModal, setEditModal] = useState(false);

  useEffect(() => {
    fetchHL7Configs();
  }, [search, asc, sortBy, deleteAlert, update, count, edit, flag]);

  const fetchHL7Configs = async () => {
    const params = {};
    params.page = count;
    params.keyword = search;
    params.asc = asc;
    params.sort_by = sortBy;
    try {
      setloader(false);
      const data = await getHL7configs(params);
      setHL7Configs(data);
      setTotalPages(data.pages);
      setloader(true);
    } catch (error) {
      console.error(error);
      setloader(true);
    }
  };

  const deleteNode = () => {
    deleteHL7Node(deleteID);
    setDeleteAlert(false);
  };

  const styles = {
    selectStyles: {
      PaperProps: {
        style: {
          backgroundColor: "#121c1b",
          color: "white",
          borderRadius: "5px",
          border: "1px solid #0fc4a0",
        },
      },
    },

    searchStyles: {
      fontFamily: "Montserrat",
      color: "#0fc4a0",
      fontSize: "14px",
    },
  };

  const handleOrder = () => {
    if (sortBy !== "") {
      setAsc((asc) => !asc);
    }
  };

  const handlePage = (page) => {
    console.log("page", page);
    console.log("totalPages", totalPages);
    if (page >= 0 && page <= totalPages) {
      setcurrentPage(page);
      setCount(page + 1);
    }
  };

  const handleModalClose = () => {
    setAdd(false);
    setEditModal(false);
  };



  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleclick = () => {
    setAdd(true);
  };

  return (
    <div className="d-flex min-vh-100 background">
      <SideBar />
      <HomeHeader />
      <div className="d-flex flex-column">
        <div className="header">
          <div className="d-flex justify-content-between mb-1">
            <h6 className="header-text" style={{ fontFamily: "Montserrat" }}>
              HL7 Configurations
            </h6>
            {/* <div className="d-flex justify-content-start gap-3">
              <div>
                <h6
                  style={{
                    fontFamily: "Montserrat",
                    color: "#0fc4a0",
                    fontSize: "14px",
                  }}
                >
                  Sort by
                  <span style={{ color: "black" }}>&nbsp;||&nbsp;</span>
                  <span
                    style={{
                      color: "rgb(249, 215, 161)",
                      cursor: "pointer",
                    }}
                    onClick={handleOrder}
                  >
                    <span>{asc ? "Asc" : "Desc"}</span>
                    {asc ? (
                      <i className="fa fa-sort-amount-asc"></i>
                    ) : (
                      <i className="fa fa-sort-amount-desc"></i>
                    )}
                  </span>
                </h6>
                <Select
                  displayEmpty
                  placeholder="Sort by"
                  className="sort"
                  name="Sort"
                  value={sortBy || ""}
                  onChange={(e) => {
                    setsortBy(e.target.value);
                  }}
                  style={{ color: "white", height: "39px" }}
                  MenuProps={styles.selectStyles}
                >
                  <MenuItem value="" style={{ fontSize: "14px" }}>
                    Select
                  </MenuItem>

                  {NODES_DROPDOWN.map((option) => (
                    <MenuItem
                      key={option.label}
                      value={option.value}
                      style={{ fontSize: "14px" }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className="mr-4 d-flex flex-column justify-content-between">
                <h6 style={styles.searchStyles}>Search</h6>
                <input
                  type="search"
                  placeholder="Search here"
                  className="search"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch(e);
                    }
                  }}
                  style={{ height: "39px", cursor: "pointer" }}
                />
              </div>
            </div> */}
            <button
              type="button"
              className="btn-class btn-width"
              onClick={handleclick}
            >
              ADD
            </button>
          </div>
          <div></div>
        </div>
        {loader ? (
          <div
            style={{
              marginLeft: "6.2rem ",
            }}
          >
            <HL7ConfigTable
              searchInput={search}
              searchflag={searchflag}
              setsearchflag={setsearchflag}
              sortby={sortBy}
              hL7Configs={hL7Configs}
              deleteAlert={deleteAlert}
              setDeleteAlert={setDeleteAlert}
              handlePage={handlePage}
              type={"HL7ConfigTable"}
              setDeleteID={setDeleteID}
              setEdit={setEdit}
              setEditModal={setEditModal}
              setFlag={setFlag}
              currentPage={currentPage}
            />
          </div>
        ) : (
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ margin: "10vw 48vw" }}
          >
            <div>
              <LoaderComponent />
            </div>
          </div>
        )}
      </div>

      {add && (
        <HL7ConfigModal
          modalState={add}
          handleClose={handleModalClose}
          setUpdate={setUpdate}
          title={"Add"}
        />
      )}

      {editModal && (
        <HL7NodeModal
          modalState={editModal}
          handleClose={handleModalClose}
          setUpdate={setUpdate}
          title={"Edit"}
          edit={edit}
        />
      )}

      {/* {deleteAlert && (
        <DeleteAlert
          type={"NodeTable"}
          id={deleteID}
          deleteAlert={deleteAlert}
          setDeleteAlert={setDeleteAlert}
          handlePage={handlePage}
          count={count}
          data={hL7Nodes}
        />
      )} */}
    </div>
  );
};

export default HL7Config;
